import type {
  CSS,
  ComponentProps,
  PropertyValue,
  VariantProps
} from '@stitches/react'
import { createStitches } from '@stitches/react'
import type { Globals, Property } from '@stitches/react/types/css'

import { colors } from './stitches.colors'
import {
  fontSizes,
  letterSpacings,
  lineHeights,
  media,
  sizes,
  space
} from './stitches.theme'
import utils from './stitches.utils'
import { GrafbaseThemes } from './themes'
import { uiBaseColorsDark, uiBaseColorsLight } from './ui.colors'
import { uiFontSizes } from './ui.font-sizes'
import { uiSizes } from './ui.sizes'

export type {
  CSS,
  PropertyValue,
  VariantProps,
  ComponentProps,
  Globals,
  Property
}
export type CSSProps = { css?: CSS }

export const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config
} = createStitches({
  theme: {
    fonts: {
      sans: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
      mono: 'Consolas, Inconsolata, Droid Sans Mono, Monaco, monospace',
      ui_sans:
        'Inter, -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, Ubuntu, roboto, noto, segoe ui, arial, sans-serif',
      ui_mono:
        '"Hack", "Fira Code", Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace'
    },
    colors: {
      ...colors.light,
      ...uiBaseColorsLight
    },
    fontWeights: {
      regular: '400',
      medium: '500',
      'semi-bold': '600',
      bold: '700'
    },
    shadows: {
      xs: '0 0 12px rgba(0,0,0,0.12)',
      sm: '0 0 14px rgba(0,0,0,0.12)',
      md: '0 0px 16px rgba(0,0,0,0.12)'
    },
    fontSizes: {
      ...fontSizes,
      ...uiFontSizes
    },
    lineHeights,
    letterSpacings,
    radii: {
      none: 0,
      xs: '0.125rem',
      sm: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
      xl: '0.75rem',
      '2xl': '1rem',
      round: '9999px'
    },
    transitions: {
      default: '0.2s ease'
    },
    space,
    sizes: {
      ...sizes,
      ...uiSizes
    }
  },
  media,
  utils
})

export const darkTheme = createTheme(GrafbaseThemes.dark, {
  colors: {
    ...colors.dark,
    ...uiBaseColorsDark
  },
  shadows: {
    xs: '0 0 12px rgba(0,0,0,0.12)',
    sm: '0 0 0 1px $colors$bg3',
    md: '0 0 0 1px $colors$bg3'
  }
})

export const injectGlobalCss = globalCss({
  html: {
    bgc: '$bg1'
  },
  body: {
    color: '$text1',
    fontSize: '$sm',
    lineHeight: '$sm',
    '@md': {
      fontSize: '$md',
      lineHeight: '$md'
    }
  }
})
